module.exports = __webpack_public_path__ + "ui-static/img/logo-launcher_dark.253751f7.svg";